import { CheckoutConfig } from '../types/checkout-config';
import { RadioOption } from '../types/form';
import { StepperVariant } from '../types/stepper';
import {
  DeliveryOptionType,
  DropOffOptionType,
  ReceiverOptionType,
} from '../types/checkout-common';
import {
  billingDetailsFormSchema,
  deliveryDetailsFormSchema,
  jobsiteDetailsFormSchema,
} from '../types/checkout-form';

export const checkoutConfig: CheckoutConfig = {
  stepperConfig: {
    jobsiteDetails: {
      showInStepper: true,
      stepLabel: 'jobsite',
      backLabel: 'jobsite info',
      fields: [...Object.keys(jobsiteDetailsFormSchema._def.schema.shape).map((e) => 'jobsiteDetails.' + e)],
    },
    deliveryDetails: {
      showInStepper: true,
      stepLabel: 'Delivery & pickup',
      backLabel: 'Delivery & pickup',
      fields: [...Object.keys(deliveryDetailsFormSchema.shape).map((e) => 'deliveryDetails.' + e)],
    },
    billingDetails: {
      showInStepper: true,
      stepLabel: 'Billing',
      backLabel: 'Billing',
      fields: [...Object.keys(billingDetailsFormSchema.shape).map((e) => 'billingDetails.' + e)],
    },
    review: {
      showInStepper: StepperVariant.BAR,
      stepLabel: 'Review',
    },
  },
  stepperOrder: [
    'jobsiteDetails',
    'deliveryDetails',
    // TODO: Commenting out as Billing step not needed for P0 release
    // 'billingDetails',
    'review',
  ],
};

export const modeOfDeliveryOptions: RadioOption[] = [
  {
    title: 'Deliver to me',
    value: DeliveryOptionType.PAID,
  },
  {
    title: 'I’ll pick up',
    value: DeliveryOptionType.SELF,
  },
];

export const modeOfReturningOptions: RadioOption[] = [
  {
    title: 'Pick up for me',
    value: DropOffOptionType.PAID,
  },
  {
    title: 'I’ll drop off',
    value: DropOffOptionType.SELF,
  },
];

export const whoWillReceiveOptions: RadioOption[] = [
  {
    title: 'Me',
    value: ReceiverOptionType.SELF,
  },
  {
    title: 'Someone else',
    value: ReceiverOptionType.OTHERS,
  },
];

export const START_CHECKOUT_SUMMARY_ANIMATION = 'start-checkout-header-animation';

export const END_CHECKOUT_SUMMARY_ANIMATION = 'end-checkout-header-animation';
